import fr from "./fr";
import en from "./en";

export type Locale = "fr" | "en";

export const messages: Record<Locale, Record<string, string>> = {
  fr,
  en,
};

export const defaultLocale: Locale = "fr";

export { fr, en };
